export default function ProductCarriers() {
  return {
    productCategory: 'UL',
    productCarrierData: [
      {
        carrierName: "Corebridge",
        displayOrder: 1,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/corebridge.png",
      },
      {
        carrierName: "John hancock",
        displayOrder: 2,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/john-hancock.png",
      },
      {
        carrierName: "Lincoln",
        displayOrder: 3,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/lincoln.png",
      },
      {
        carrierName: "Nationwide",
        displayOrder: 4,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/nationwide.png",
      },
      {
        carrierName: "Pacific life",
        displayOrder: 5,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/pacific-life.png",
      },
      {
        carrierName: "Protective",
        displayOrder: 6,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/protective.png",
      },
      {
        carrierName: "Securian",
        displayOrder: 7,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/securian.png",
      },
      {
        carrierName: "Symetra",
        displayOrder: 8,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/symetra.png",
      },
      {
        carrierName: "Transamerica",
        displayOrder: 9,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/transamerica.png",
      },
      {
        carrierName: "Mass Mutual",
        displayOrder: 10,
        logoLink: "https://assets.covrtech.com/Consumer/logos/Carriers/mass-mutual.png",
      },
    ],
  }
}
